'use strict';

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var CID = require('cids');

var withIs = require('class-is');
/**
 * Represents an immutable block of data that is uniquely referenced with a cid.
 *
 * @constructor
 * @param {Buffer} data - The data to be stored in the block as a buffer.
 * @param {CID} cid - The cid of the data
 *
 * @example
 * const block = new Block(new Buffer('a012d83b20f9371...'))
 */


var Block = /*#__PURE__*/function () {
  function Block(data, cid) {
    _classCallCheck(this, Block);

    if (!data || !Buffer.isBuffer(data)) {
      throw new Error('first argument  must be a buffer');
    }

    if (!cid || !CID.isCID(cid)) {
      throw new Error('second argument must be a CID');
    }

    this._data = data;
    this._cid = cid;
  }
  /**
   * The data of this block.
   *
   * @type {Buffer}
   */


  _createClass(Block, [{
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(val) {
      throw new Error('Tried to change an immutable block');
    }
    /**
     * The cid of the data this block represents.
     *
     * @type {CID}
     */

  }, {
    key: "cid",
    get: function get() {
      return this._cid;
    },
    set: function set(val) {
      throw new Error('Tried to change an immutable block');
    }
  }]);

  return Block;
}();

module.exports = withIs(Block, {
  className: 'Block',
  symbolName: '@ipfs/js-ipfs-block/block'
});